import React from 'react'
import Rows from '../Rows'

export default ({ items, ...rest }) => (
  <div style={styles.container}>
    <Rows isItem {...rest} withCustom />
  </div>
)

const styles = {
  container: {
    paddingLeft: '40px',
  },
}
